module.exports = __webpack_public_path__ + "img/b012_1.34775e4a.jpg";